<template>
  <div>
    <Alert :plan="false" :backButton="true" 
      :isGame="false"
    />
    <!--  justify-content-center  style="height: 56vh !important" h-100 -->
    <div
      class="row pl-5 d-flex align-items-center"
      style="height: 56vh !important"
    >
      <div class="col-md-4">
        <Stepper :cadastro="true" />
      </div>
      <div
        class="col-md-8 d-flex flex-column justify-content-center align-items-center form"
      >
        <div class="card w-75 mb-1 mt-1">
          <div class="row">
            <div class="col-md-6">
              <Input
                type="text"
                title="Nome"
                v-model="user.name"
                placeholder="Nome"
              />
            </div>
            <div class="col-md-6">
              <Input
                type="text"
                title="Sobrenome"
                v-model="user.sobrenome"
                placeholder="Sobrenome"
              />
            </div>
            <div class="col-md-12">
              <Input
                type="text"
                title="E-mail"
                v-model="user.email"
                placeholder="E-mail"
              />
            </div>
            <div class="col-md-12">
              <Input
                type="password"
                v-model="user.password"
                placeholder="Senha"
                title="Senha"
              />
            </div>
            <div class="col-md-12 mt-1">
              <input
                type="checkbox"
                v-model="checked"
                :checked="checked ? 'checked' : ''"
              />
              <span class="concordo ml-2"
                >Eu li e concordo com os
                <a href="#" @click="openTerms"
                  ><b>Termos de Uso e as Politicas de Privacidade.</b></a
                ></span
              >
            </div>
          </div>
          <button @click="register" class="btn-login">CONTINUAR</button>
        </div>
        <br />
        <br />
        <div class="text-center mt-2">
          <span class="label"
            >Já tem cadastro?
            <a
              @click="$router.push({ path: '/login' })"
              href=""
              style="color: #8d4d9a"
              ><b>Faça login.</b></a
            ></span
          >
        </div>
      </div>
    </div>
    <Alert />
  </div>
</template>

<script>
import Input from "../components/Input";
import Alert from "../components/AlertaPlano";
import Stepper from "../components/Stepper";
import { termos } from "../assets/js/termos";
export default {
  name: "Cadastro",
  components: {
    Input,
    Alert,
    Stepper,
  },
  data: () => ({
    user: {
      name: "",
      sobrenome: "",
      email: "",
      password: "",
      planos_id: "",
      stripe_id: "",
    },
    checked: false,
  }),
  mounted(){
    this.$store.commit("jogo", false);

    if(localStorage.getItem('t')){
      if(localStorage.getItem('abriuPagamento'))
        this.$router.push({path: '/assinatura/planos'})
      else
        this.$router.push({path: '/assinatura/pagamento'})
    }else{
      if(this.$store.getters.getItemInCart.payload == undefined){
        this.$store.commit("setStateModal", {
          visible: true,
          title: "ATENÇÃO",
          type: "warning",
          message: `Selecione um plano para continuar`,
        });
        this.$router.push({ path: "/assinatura/planos" });
      }
    }
  },
  methods: {
    openTerms: function () {
      this.$store.commit("setStateModal", {
        visible: true,
        title: "ATENÇÃO",
        type: "warning",
        message: termos(),
        callbackOk: () => (this.checked = true),
        callbackCancel: () =>
          this.$store.commit("setStateModal", { visible: false }),
      });
    },
    register: async function () {
      this.$store.commit("loading", true);
      let user = { ...this.user };
      if (this.checked) {
        user.planos_id = this.$store.getters.getItemInCart.payload.id;
        // this.$axios
        //   .post(`register`, user)
        //   .then((res) => res.data)
        //   .then(async (res) => {
        //     localStorage.setItem("t", JSON.stringify(res.token));
        //     await this.$store.commit("loading", false);           
        //       await setTimeout(async () => {
        //         await this.$store.commit("logado", true);
        //       }, 1000)        
        //      await this.$router.push({path: '/assinatura/pagamento'})
 

        this.$axios
          .post("https://api2.arecreativa.com.br/create_customer", {
            name: this.user.name + " " + this.user.sobrenome,
            email: this.user.email.trim(),
          })
          .then((res) => {
            user.stripe_id = res.data.id;

            this.$axios
              .post(`register`, user)
              .then((res) => res.data)
              .then(async (res) => {
                localStorage.setItem("t", JSON.stringify(res.token));
                await this.$store.commit("loading", false);
                await setTimeout(async () => {
                  await this.$store.commit("logado", true);
                }, 1000);
                await this.$router.push({ path: "/assinatura/pagamento" });
              })
              .catch(async (e) => {
                this.$store.commit("loading", false);
                this.$store.commit("setStateModal", {
                  visible: true,
                  title: e.response.data.message,
                  type: "warning",
                  message:
                    "Dados inválidos, verifique os campos e tente novamente.",
                });
              });
          })
          // .catch((err) => {
          //   this.$store.commit("loading", false);
          //   this.$store.commit("setStateModal", {
          //     visible: true,
          //     title: err.response.data.message,
          //     type: "warning",
          //     message: err.response.data.erros.email[0],
          //   });
          // });
     // })
      } else {
        this.$store.commit("loading", false);
        this.$store.commit("setStateModal", {
          visible: true,
          title: "ATENÇÃO",
          type: "warning",
          message: "Leia as Politicas de Privacidade antes de continuar!",
        });
      }
    
  },
}
}
</script>
<style scoped>
.card {
  border: none;
  padding: 30px 30px;
  box-shadow: 10px 10px 30px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  font-size: 14px !important;
  position: relative;
}

a {
  color: #8d4d9a;
}

a:hover {
  color: #5f2d69;
}

.btn-login {
  width: 100%;
  height: 50px;
  bottom: -50px;
  left: 0;
  border: none;
  font-size: 18px;
  background-color: #8d4d9a;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  letter-spacing: 2px;
  position: absolute;
  text-transform: uppercase;
  transition: ease 0.5s;
}

.btn-login:hover {
  transform: scale(1.05);
}

.label {
  font-size: 20px;
  letter-spacing: 2px;
  text-transform: uppercase;
}
</style>